export default class DataLayer {
  buttons
  utm_params = ['utm_campaign', 'utm_source', 'utm_content', 'utm_medium', 'custom_campaign', 'custom_source', 'custom_content', 'custom_medium']

  constructor() {
    window.dataLayer = window.dataLayer || []

    dataLayer.push({
      'screen.name': document.title,
      'screen.language': document.documentElement.lang,
    })

    const urlParams = new URLSearchParams(window.location.search)

    Array.from(urlParams.keys()).map((key) => {
      if (!this.utm_params.includes(key)) return
      if (!urlParams.get(key)) return
      if (key.includes('custom')) return sessionStorage.setItem(key.replace('custom', 'utm'), urlParams.get(key))

      sessionStorage.setItem(key, urlParams.get(key))
    })

    this.buttons = document.querySelectorAll('[data-tracking]')

    Array.from(this.buttons).map((button) => {
      const isReferrer = this.utm_params.some((p) => !!sessionStorage.getItem(p))

      if (button.hasAttribute('data-tracking-utm') && isReferrer) {
        const platform = button.getAttribute('data-tracking-platform')
        const url = new URL(button.getAttribute('href'))

        if (!platform) {
          this.utm_params.map((p) => {
            const value = sessionStorage.getItem(p)

            if (!value) return

            url.searchParams.set(p, value)
          })
        }

        if (platform === 'ios') {
          const ct = this.utm_params
            .reduce((res, p) => {
              const value = sessionStorage.getItem(p)

              return value ? [...res, value] : res
            }, [])
            .join('_')

          url.searchParams.set('ct', ct)
          url.searchParams.set('mt', '8')
          url.searchParams.set('pt', '550986')
        }

        if (['android', 'google-play'].some((i) => i === platform)) {
          const referrer = this.utm_params
            .reduce((res, p) => {
              const value = sessionStorage.getItem(p)

              return value ? [...res, `${p}=${value}`] : res
            }, [])
            .join('&')

          url.searchParams.set('referrer', referrer)
        }

        button.setAttribute('href', url.href)
      }

      button.addEventListener('click', (e) => {
        dataLayer.push(
          Object.keys(e.currentTarget.dataset).reduce((res, key) => {
            if (!e.currentTarget.dataset[key]) return res

            const replace_params = { tracking: '', cta: 'cta.', app: 'app.' }
            const regExp = new RegExp(Object.keys(replace_params).join('|'), 'gi')

            return {
              ...res,
              [key
                .replace(regExp, function (matched) {
                  return replace_params[matched.toLowerCase()]
                })
                .toLocaleLowerCase()]: e.currentTarget.dataset[key],
            }
          }, {})
        )
      })
    })
  }
}
